/**
 * Validation V2 Repository - GraphQL Fragments
 *
 * Reusable field selections for Validation queries and mutations.
 * Ensures 100% field parity with backend GraphQL schema (30 fields).
 */

import { gql } from '@apollo/client';

export const VALIDATION_FIELDS_FRAGMENT = gql`
  fragment ValidationFields on Validation {
    # Identity (6 fields)
    id
    tenantId
    name
    code
    description
    validationType

    # Rule Definition (5 fields)
    fieldPath
    rule {
      ... on GqlRegexRule {
        pattern
        flags
      }
      ... on GqlRangeRule {
        min
        max
        inclusive
      }
      ... on GqlLengthRule {
        min
        max
      }
      ... on GqlOneOfRule {
        allowedValues
      }
      ... on GqlExistsRule {
        entityType
        idField
      }
      ... on GqlUniqueRule {
        scope
      }
      ... on GqlExpressionRule {
        expression
        language
      }
      ... on GqlStandardRule {
        standard
        version
        profile
      }
    }
    errorMessage
    severity
    parameters

    # Execution (3 fields)
    executionPhase
    dependsOn
    conditionalLogic

    # Error Handling (2 fields)
    isBlocking
    fixSuggestion

    # Lifecycle (2 fields)
    active
    effectiveDates {
      start
      end
    }

    # Audit Trail (5 fields)
    createdAt
    updatedAt
    createdBy
    updatedBy
    auditVersion

    # Metadata (3 fields)
    tags
    complianceFrameworks
    customMetadata

    # Append-Only (4 fields)
    parentId
    originalId
    recordVersion
    isActive
  }
`;
